import { BackgroundVariant, ConnectionLineType } from '@xyflow/react'

export const REACT_FLOW_FIT_VIEW_OPTIONS = { padding: 0.3, maxZoom: 0.85 } as const

export const REACT_FLOW_FIT_VIEW_ANIMATED = {
  ...REACT_FLOW_FIT_VIEW_OPTIONS,
  duration: 300,
} as const

export const REACT_FLOW_CONFIG = {
  connectionLineType: ConnectionLineType.SmoothStep,
  minZoom: 0.2,
  maxZoom: 2,
  defaultEdgeOptions: { type: 'smoothstep', animated: false },
} as const

export const BACKGROUND_CONFIG = {
  variant: BackgroundVariant.Dots,
  gap: 20,
  size: 1,
} as const

export const MINIMAP_CONFIG = {
  position: 'bottom-right' as const,
  maskColor: 'rgba(0, 0, 0, 0.1)',
  className: 'agency-flow-minimap',
}

export const CANVAS_BACKGROUND_STYLE = {
  backgroundImage: `radial-gradient(circle at 20% 80%, rgba(255, 182, 153, 0.3) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(255, 244, 214, 0.5) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(255, 182, 153, 0.1) 0%, transparent 50%)`,
} as const
